<template>
  <div>
    <div class="min-h">

      <div class="quote-wrapper">
        <blockquote class="text">
          <p>
            <router-link :class="!family[3] ? 'links' : 'no-links'" :to="!family[3] ? '/about/' + family[0] : ''"
              v-for="(family, index) in $store.getters.FAMILY" :key="'family' + index"
              :style="'color:' + family[2] + '; font-size:' + family[1] + 'px;'"
              @mouseover.native="!family[3] ? moveColor(index) : moveColorLight(index)">{{
                family[0] }}
            </router-link>
          </p>
        </blockquote>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    moveColor(index) {
      // console.log(11111);
      this.$store.state.family[index][2] = this.colorRand();
      this.$forceUpdate();
      // console.log(index);
    },
    moveColorLight(index) {
      // console.log(11111);
      this.$store.state.family[index][2] = this.colorRandLight();
      this.$forceUpdate();
      // console.log(index);
    },
    getRandomInt(min, max) {
      return Math.round(Math.random() * (max - min) + min);
    },
    toHex(c) {
      var hex = c.toString(16);
      return hex.length == 1 ? "0" + hex : hex;
    },
    colorRand() {
      return "#" + this.toHex(this.getRandomInt(120, 255)) + this.toHex(this.getRandomInt(120, 255)) + this.toHex(this.getRandomInt(120, 255));
      // return '#' + (Math.floor(Math.random() * (6710886 - 2236962 + 1) + 2236962)).toString(16);
      // return '#' + (Math.floor(Math.random() * (16777215 - 1048576 + 1) + 1048576)).toString(16);
    },
    colorRandLight() {
      return "#" + this.toHex(this.getRandomInt(210, 255)) + this.toHex(this.getRandomInt(210, 255)) + this.toHex(this.getRandomInt(210, 255));
      // return '#' + (Math.floor(Math.random() * (6710886 - 2236962 + 1) + 2236962)).toString(16);
      // return '#' + (Math.floor(Math.random() * (16777215 - 1048576 + 1) + 1048576)).toString(16);
    },

  }
}
</script>
<style>
.min-h {
  /* background: url('~@/assets/bg.svg') */
  min-height: calc(100vh - 150px);

}



.quote-wrapper {
  height: 625px;
  position: relative;
  width: 625px;
  margin: 0 auto;
}

@media (max-width: 658px) {
  .quote-wrapper {
    zoom: .4;
  }
}

@media (max-width: 250px) {
  .quote-wrapper {
    zoom: .2;
  }
}

.text {
  /* background: radial-gradient(
    ellipse at center,
    rgba(38, 38, 38, 1) 0%,
    rgb(38, 38, 38) 70%,
    rgba(0, 128, 172, 0) 70.3%
  ); */
  overflow: hidden;
  height: 100%;
  width: 100%;
}


.text p {
  font-size: 18px;
  /* font-style: italic; */
  height: 100%;
  line-height: 1.2;
  padding: 0;
  /* text-align: center; */
  text-align: justify;
  /* text-shadow: 0.5px 0.5px 1px rgba(0, 0, 0, 0.3); */
}

.text::before {
  content: "";
  float: left;
  height: 100%;
  width: 50%;
  shape-outside: polygon(0 0,
      98% 0,
      50% 6%,
      23.4% 17.3%,
      6% 32.6%,
      0 50%,
      6% 65.6%,
      23.4% 82.7%,
      50% 94%,
      98% 100%,
      0 100%);
  shape-margin: 0;
}

.text p::before {
  content: "";
  float: right;
  height: 100%;
  width: 50%;
  shape-outside: polygon(2% 0%,
      100% 0%,
      100% 100%,
      2% 100%,
      50% 94%,
      76.6% 82.7%,
      94% 65.6%,
      100% 50%,
      94% 32.6%,
      76.6% 17.3%,
      50% 6%);
  shape-margin: 0;
}

/* a {
  cursor: pointer;
} */

.links,
.no-links {
  text-decoration: none;
  font-family: Philosopher;
}

.links {
  font-weight: 300;
}

.no-links {
  cursor: auto;
  font-family: Philosopher;
  font-weight: 500;
}

.links:hover {
  opacity: .8;
}
</style>
